import { makeStyles } from '@material-ui/core/styles';

export const useConversationSearchModalStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: theme.shape.borderRadius,
    minHeight: '50dvh',
    maxHeight: '80dvh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  searchInputContainer: {
    alignItems: 'center',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: 'none',
    display: 'flex',
    margin: theme.spacing(3, 0, 2, 0),
    padding: theme.spacing(0.75, 2),
    width: '100%'
  },
  searchInput: {
    marginLeft: theme.spacing(1),
    flex: 1,
    fontSize: '0.95rem'
  },
  clearButton: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  dialogContent: {
    padding: theme.spacing(0),
    marginTop: theme.spacing(1)
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  resultItem: {
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
}));
